var React = require('react');

function LandingCross (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.70711 9.24253C1.31658 9.63305 0.683418 9.63305 0.292893 9.24253C-0.097631 8.85201 -0.0976311 8.21884 0.292893 7.82832L3.12128 4.99993L0.292893 2.17154C-0.0976311 1.78102 -0.097631 1.14785 0.292893 0.757329C0.683418 0.366805 1.31658 0.366805 1.70711 0.757329L4.53549 3.58572L7.36396 0.757249C7.75449 0.366724 8.38765 0.366724 8.77817 0.757249C9.1687 1.14777 9.1687 1.78094 8.77817 2.17146L5.94971 4.99993L8.77817 7.8284C9.1687 8.21892 9.1687 8.85209 8.77817 9.24261C8.38765 9.63313 7.75449 9.63313 7.36396 9.24261L4.53549 6.41414L1.70711 9.24253Z","fill":"#222224"}));
}

LandingCross.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = LandingCross;

LandingCross.default = LandingCross;
